import { Injectable } from '@angular/core';
import { Expense } from '../../interface/expense/expense';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {

  constructor(private _httpExpense:HttpService) { }

  getExpenseList(){
    return this._httpExpense.get('/Expenses');
  }
 public async sendExpenseRecord(data:Expense):Promise<Expense>{
    return await firstValueFrom( this._httpExpense.post('/Expenses',data));
  }
  public async update(id:number,data:Expense):Promise<Expense>{
    return await firstValueFrom(this._httpExpense.patch('/Expenses/',id,data));
  }
  public async delete(id:number):Promise<Expense>{
    return await firstValueFrom(this._httpExpense.delete('/Expenses/',id));
  }
  getExpenseHaedList(){
    return this._httpExpense.get('/Expenseheads');
  }
}
